import { PhoneType } from "../../types";
import { formatFullStreet } from "../../util/format";
import {
  mapCountry,
  mapDateDocumentToPageModel,
  mapDatePageModelToRequest,
  mapPartialDateDocumentToPageModel,
  mapPartialDatePageModelToRequest,
  mapPhoneDocumentToPageModel,
  mapPhonePageModelToRequest,
} from "../shared/mappers";
import IndustrySectorMapper from "./industry-sector/mapper";
import { CompanyModel, LegalForm } from "./types";
import {
  CompanyBasicDataDto,
  CompanyDocument,
} from "../../api/commercial/generated-types";

const mapDocumentToPageModel = (document: CompanyDocument): CompanyModel => {
  let mappedModel: CompanyModel = {
    ehraid: document.ehraid,
    uid: document.uid,
    chid: document.chid,
    isCompanyManuallyEntered: document.isCompanyManuallyEntered,
    name: document.name,
    fullStreet: formatFullStreet(document.address),
    address: {
      ...document.address,
      country: mapCountry(document.address ? document.address.country : null),
    },
    phone: document.isCompanyManuallyEntered
      ? mapPhoneDocumentToPageModel(document.phone)
      : document.phone,
    legalForm: document.legalForm as LegalForm,
    foundationDate: document.isCompanyManuallyEntered
      ? mapPartialDateDocumentToPageModel(document.foundationDate)
      : mapDateDocumentToPageModel(document.foundationDate),
    capitalNom: document.capitalNom,
    enteredInTradeRegistryDate: mapDateDocumentToPageModel(
      document.enteredInTradeRegistryDate,
    ),
    industryBranchCode: undefined,
  };

  if (document.isCompanyManuallyEntered) {
    mappedModel = {
      ...mappedModel,
      industryNogaCode: null,
      industryBranchCode: document.industry && document.industry.branchCode,
      industrySubBranchCode:
        document.industry && document.industry.subBranchCode,
    };
  } else {
    mappedModel = {
      ...mappedModel,
      industryNogaCode: document.industry && document.industry.nogaCode,
      industryBranchCode: null,
      industrySubBranchCode: null,
    };
  }
  return mappedModel;
};

const mapPageModelToRequest = (
  data: CompanyModel,
  basicAccountApplicationRef: string,
): CompanyBasicDataDto => {
  let request: CompanyBasicDataDto = {
    basicAccountApplicationRef,
    ehraid: data.ehraid,
    uid: data.uid,
    chid: data.chid,
    name: data.name,
    address: {
      ...data.address,
      country: mapCountry(data.address.country),
    },
    phone:
      typeof data.phone === "string"
        ? // string if the company is automatically selected.
          (data.phone as string)
        : // manually selecting a company gives an object.
          mapPhonePageModelToRequest(data.phone as PhoneType),
    legalForm: data.legalForm,
    foundationDate: data.ehraid
      ? mapDatePageModelToRequest(data.foundationDate)
      : mapPartialDatePageModelToRequest(data.foundationDate),
    capitalNom: data.capitalNom,
    enteredInTradeRegistryDate: mapDatePageModelToRequest(
      data.enteredInTradeRegistryDate,
    ),
  };
  if (data.ehraid) {
    request = {
      ...request,
      industryNogaCode: IndustrySectorMapper.mapPageModelToRequest(data),
    };
  } else {
    request = {
      ...request,
      industryBranchCode: data.industryBranchCode,
      industrySubBranchCode: data.industrySubBranchCode,
    };
  }
  return request;
};

const CompanyMapper = {
  mapPageModelToRequest,
  mapDocumentToPageModel,
};

export default CompanyMapper;
